var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

var getStyle = function (line) {
  if (line === 1) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
  }

  return {
    display: "-webkit-box",
    wordBreak: "break-all",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: line,
    overflow: "hidden",
    textOverflow: "ellipsis"
  };
};

export var ContentWrapper = function (_a) {
  var _b = _a.line,
      line = _b === void 0 ? 1 : _b,
      _c = _a.className,
      className = _c === void 0 ? "" : _c,
      children = _a.children,
      _d = _a.color,
      color = _d === void 0 ? "" : _d,
      fontSize = _a.fontSize,
      _e = _a.lineHeight,
      lineHeight = _e === void 0 ? "1.5" : _e,
      _f = _a.bold,
      bold = _f === void 0 ? false : _f,
      fontFamily = _a.fontFamily,
      styles = _a.styles;
  return React.createElement("div", {
    className: className,
    style: __assign(__assign(__assign({}, getStyle(line)), {
      color: color,
      lineHeight: lineHeight,
      fontSize: fontSize,
      fontWeight: bold ? "bold" : "normal",
      fontFamily: fontFamily
    }), styles)
  }, children);
};